import { render, staticRenderFns } from "./Big.vue?vue&type=template&id=35c58f9c&"
import script from "./Big.vue?vue&type=script&lang=js&"
export * from "./Big.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports